import {
    isProduction,
    convertTimestampToMoment,
} from '../utils';
import {
    INFO_EMAIL,
    CONTACT_PHONE,
    CONTACT_EMAIL,
    WEBSITE_URL,
} from '../constants';
import { SERVICES } from '../constants/servicesList';

const TO_EMAIL = `"Matthew Skinner" <${isProduction() ? CONTACT_EMAIL : 'me@jake-brown.co.uk'}>`;
const FROM_EMAIL = `"Clear H2O Window Cleaning Ltd" <${INFO_EMAIL}>`;

export default {
    createConfigNewBooking: (data) => {
        const bookingMomentObj = convertTimestampToMoment(data.date_time);
        const selectedService = SERVICES[data.selected_service];

        const createTimeAndAddressDetail = (booking) => {
            return `${bookingMomentObj.format('LLLL')} for your property at ${booking.address_line_1}, ${booking.city}, ${booking.postcode}`;
        };

        return {
            admin: {
                from: FROM_EMAIL,
                to: TO_EMAIL,
                subject: `New Booking Notification - ${bookingMomentObj.format('LLLL')}`,
                html: `
                    <div>
                        <p>Hi,</p>
                        <p>A new booking has been created via the online booking form:</p>
                        <p><b>Date & Time: </b>${bookingMomentObj.format('LLLL')}</p>
                        <p><b>Customer Name: </b>${data.full_name}</p>
                        <p><b>Contact Number: </b>${data.contact_number}</p>
                        <p><b>Email Address: </b>${data.email_address}</p>
                        <p><b>Property Address: </b>${data.address_line_1}, ${data.city}, ${data.postcode}</p>
                        <p><b>Selected Service: </b>${selectedService.service}</p>
                        <p><b>Addons: </b>${data.selected_addons.length ? data.selected_addons : 'N/A'}</p>
                        <p><b>Total Charge: </b>£${data.total_charge}</p>
                        <p><b>Property Type: </b>${data.property_type}</p>
                        <p><b>Has Parking Available?: </b>${data.has_parking_available}</p>
                        <p><b>Has Access to Back of Property?: </b>${data.has_access_to_back_of_property}</p>
                        <p><b>Additional Comments: </b>${data.additional_comments}</p>
                        <br />
                        <br />
                        <p style="font-size: 12px">
                            This email was automatically generated via our online booking service, please do not reply. Our terms and conditions can be viewed <a href="${WEBSITE_URL}/terms-and-conditions">here</a>.            
                        </p>
                    </div>
                `,
            },
            customer: {
                from: FROM_EMAIL,
                to: data.email_address,
                subject: `Booking Confirmation - Reference No. ${data.uuid}`,
                html: `
                    <div>
                        <p>Hi ${data.full_name},</p>
                        <p>Your booking has been confirmed for ${createTimeAndAddressDetail(data)}.</p>
                        <p>If you wish you amend your booking, please do so by visiting this url: ${WEBSITE_URL}/booking/${data.uuid}</p>
                        <p>For any questions regarding your booking, please contact me on ${CONTACT_PHONE} or ${CONTACT_EMAIL}.</p>
                        <p>Kind regards,</p>
                        <p>Matthew Skinner</p>
                        <p>Clear H2O Window Cleaning Ltd</p>
                        <br>
                        <p style="font-size: 12px">
                            This email was automatically generated via our online booking service, please do not reply. Our terms and conditions can be viewed <a href="${WEBSITE_URL}/terms-and-conditions">here</a>.            
                        </p>
                    </div>
                `,
            },
        };
    },

    createConfigAmendedBooking: (data) => {
        const newDateMomentObj = convertTimestampToMoment(data.date_time);
        const previousDateMomentObj = convertTimestampToMoment(data.previous_date_time);

        return {
            admin: {
                from: FROM_EMAIL,
                to: TO_EMAIL,
                subject: `Booking Amended Notification - ${newDateMomentObj.format('LLLL')}`,
                html: `
                    <div>
                        <p>Hi,</p>
                        <p>A customer has amended their booking date & time:</p>
                        <p><b>New Booking Date & Time: </b>${newDateMomentObj.format('LLLL')}</p>
                        <p><b>Previous Booking Date & Time: </b>${previousDateMomentObj.format('LLLL')}</p>
                        <p><b>Customer Name: </b>${data.full_name}</p>
                        <p><b>Email Address: </b>${data.email_address}</p>
                        <p><b>Property Address: </b>${data.address_line_1}, ${data.city}, ${data.postcode}</p>
                        <br />
                        <br />
                        <p style="font-size: 12px">
                            This email was automatically generated via our online booking service, please do not reply. Our terms and conditions can be viewed <a href="${WEBSITE_URL}/terms-and-conditions">here</a>.            
                        </p>
                    </div>
                `,
            },
            customer: {
                from: FROM_EMAIL,
                to: data.email_address,
                subject: `Booking Amended - Reference No. ${data.uuid}`,
                html: `
                    <div>
                        <p>Hi ${data.full_name},</p>
                        <p>Your booking has been amended and confirmed for ${newDateMomentObj.format('LLLL')}.</p>
                        <p>Kind regards,</p>
                        <p>Matthew Skinner</p>
                        <p>Clear H2O Window Cleaning Ltd</p>
                        <br>
                        <p style="font-size: 12px">
                            This email was automatically generated via our online booking service, please do not reply. Our terms and conditions can be viewed <a href="${WEBSITE_URL}/terms-and-conditions">here</a>.            
                        </p>
                    </div>
                `,
            },
        };
    },

    createPaymentFailureNotification: (data) => {
        const bookingMomentObj = convertTimestampToMoment(data.date_time);
        const selectedService = SERVICES[data.selected_service];

        return {
            admin: {
                from: FROM_EMAIL,
                to: TO_EMAIL,
                subject: `Payment Failed Notification - ${bookingMomentObj.format('LLLL')}`,
                html: `
                    <div>
                        <p>Hi,</p>
                        <p>Someone has attempted to create a new booking via the online booking form but Stripe received an error processing their request.</p>
                        <p>Please check Stripe to see if you have received their payment and contact the customer directly to confirm their booking:</p>
                        <p><b>Date & Time: </b>${bookingMomentObj.format('LLLL')}</p>
                        <p><b>Customer Name: </b>${data.full_name}</p>
                        <p><b>Contact Number: </b>${data.contact_number}</p>
                        <p><b>Email Address: </b>${data.email_address}</p>
                        <p><b>Property Address: </b>${data.address_line_1}, ${data.city}, ${data.postcode}</p>
                        <p><b>Selected Service: </b>${selectedService.service}</p>
                        <p><b>Addons: </b>${data.selected_addons.length ? data.selected_addons : 'N/A'}</p>
                        <p><b>Total Charge: </b>£${data.total_charge}</p>
                        <p><b>Property Type: </b>${data.property_type}</p>
                        <p><b>Has Parking Available?: </b>${data.has_parking_available}</p>
                        <p><b>Has Access to Back of Property?: </b>${data.has_access_to_back_of_property}</p>
                        <p><b>Additional Comments: </b>${data.additional_comments}</p>
                        <br />
                        <br />
                        <p style="font-size: 12px">
                            This email was automatically generated via our online booking service, please do not reply. Our terms and conditions can be viewed <a href="${WEBSITE_URL}/terms-and-conditions">here</a>.            
                        </p>
                    </div>
                `,
            },
        };
    },
};
